/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useMemo } from 'react'
import { useFilterMultipleState } from '@vtex/admin-ui'
import { useLocalStorage } from '@/hooks/useLocalStorage'

export function useFilterMultiple(key: string) {
  const state = useFilterMultipleState<any>()

  const [appliedItems, setAppliedItems] = useLocalStorage(
    key,
    state.appliedItems
  )

  useEffect(() => {
    if (!state.menu.mounted || !appliedItems) return

    state.combobox.setSelectedItems(appliedItems)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.menu.mounted])

  const finalState = useMemo(
    () => ({
      ...state,
      appliedItems,
      hasFilterValueApplied:
        state.hasFilterValueApplied || !!appliedItems.length,
      setAppliedItems,
      onClear: () => {
        state.onClear()
        setAppliedItems([])
      },
      onChange: () => {
        state.onChange()
        setAppliedItems(state.combobox.selectedItems)
      },
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state, appliedItems]
  )

  return finalState
}
